// no way - importing polyfill is wrong .... import './polyfills';
import 'hammerjs';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { RootModule } from './app/root.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

// , {useDebug: false} works not more angular 6
// useDebug will add ngReflects to the dom nodes
platformBrowserDynamic()
	.bootstrapModule(RootModule, { applicationProviders: [provideZoneChangeDetection()] })
	.catch((err) => console.error(err));
